/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import config from '../../../config';

export const getProductsDiscount = (productFamilyIds, productConfig = null, components = null) => {
  let params = { ids: productFamilyIds };

  if (productConfig) {
    params = {...params, product_config: productConfig};
  }

  if (components && Object.keys(components).length > 0) {
    Object.entries(components).map(([attribute, value]) => {
    params = { ...params, [attribute]: value };
  });

  }

  const queryParams = queryString.stringify(params ,{ arrayFormat: 'bracket' });

  return $.ajax({
    method: 'GET',
    url: `${config.api}/products-discounts?${queryParams}`
  });
};



// WEBPACK FOOTER //
// ./src/Common/Providers/ProductsDiscountApi.js